import React, { Component } from 'react';
import Combobox from 'react-widgets/lib/Combobox';

//Create class to add featured product
class AddFeaturedProduct extends Component {

	constructor(props) {
		super(props);
		this.state = {
			product: null
		}
		this.changeValue = this.changeValue.bind(this);
		this.addFeaturedProduct = this.addFeaturedProduct.bind(this);
	}

	changeValue(newOption) {
		this.setState({
			product: newOption
		})
	}

	addFeaturedProduct() {
		if (this.state.product) {
			this.props.addFeaturedProduct(this.state.product);
			this.clearState();
		}
	}

	clearState() {
		this.setState({
			product: ""
		})
	}

	render() {
		return (
			<div style={{ marginLeft: "4.2%", marginTop: "5vh" }}>
				<div className="toolbar space">
					<Combobox
						className="select-product"
						data={this.props.products}
						dataKey={'sku'}
						textField={'descripcion'}
						value={this.state.product}
						placeholder="Selecciona un producto"
						onChange={this.changeValue}
						filter='contains'
						style={{ fontSize: "16px" }}
					/>
					<button className="buttonAdd" onClick={this.addFeaturedProduct}>Agregar Producto</button>
				</div>
			</div>
		);
	}
}

export default AddFeaturedProduct;